import { Share } from '@capacitor/share';
import { isNativePlatform } from './platform';

/**
 * Share content using the native Android share sheet when inside Capacitor,
 * or the Web Share API / clipboard fallback on web.
 *
 * @param {Object} options
 * @param {string} options.title - Share title
 * @param {string} options.text - Share text
 * @param {string} options.url - URL to share
 * @param {Object} options.dialogTitle - Dialog title (Android only)
 */
export async function shareContent({ title, text, url, dialogTitle }) {
  if (isNativePlatform()) {
    try {
      await Share.share({
        title: title || '',
        text: text || '',
        url: url || '',
        dialogTitle: dialogTitle || 'Share',
      });
    } catch (e) {
      console.warn('Native share failed:', e);
      fallbackShare(url, text);
    }
  } else if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.warn('Web share failed:', e);
      }
    }
  } else {
    fallbackShare(url, text);
  }
}

function fallbackShare(url, text) {
  const content = url || text || '';
  if (content) {
    navigator.clipboard?.writeText(content).then(() => {
      alert('Link copied to clipboard!');
    }).catch(() => {
      window.open(url, '_blank');
    });
  }
}
